import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { ToggleLink } from "./spiMasked.style";
import SpiMasker from "../../../utilities/spiMasker";

const SpiMasked = ({ children, type = "", timeout = null }) => {
    const { t } = useTranslation("components.global.spiMasked");
    const [maskedValue, setMaskValue] = useState("");
    const [showTimeout, saveTimeout] = useState();
    const TIMEOUT_MS = 5000;

    useEffect(
        () => {
            maskValue();
        },
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [children]);

    const maskValue = (raw = false) => {
        if (raw || !SpiMasker[type]) {
            setMaskValue(children);
        } else {
            setMaskValue(SpiMasker[type](children));
        }
    };

    const showValue = () => {
        maskValue(true);
        const localTimeout = setTimeout(() => {
            maskValue();
            clearTimeout(localTimeout);
            saveTimeout(null);
        }, timeout || TIMEOUT_MS);
        saveTimeout(localTimeout);
    };

    const hideValue = () => {
        if (showTimeout) {
            clearTimeout(showTimeout);
            saveTimeout(null);
        }

        maskValue();
    };

    return (
        <>
            <span>{maskedValue}</span>
            {!showTimeout && <ToggleLink onClick={showValue}>{t("show")}</ToggleLink>}
            {showTimeout && <ToggleLink onClick={hideValue}>{t("hide")}</ToggleLink>}
        </>
    );
};

export default SpiMasked;
